<template>
  <modal :showing="show" :large="false">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">Historique</h6>
      <div class="closeFeature" @click="closeModal"></div>
    </d-card-header>
    <d-card-body>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Date</th>
            <th>Nombre de jours</th>
            <th>Mode</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(mvt, idx) in historyList" :key="idx">
            <td>{{ formatDate(mvt.date) }}</td>
            <td>{{ mvt.amount }} jours</td>
            <td>{{ formatMode(mvt.mode) }}</td>
          </tr>
        </tbody>
      </table>
    </d-card-body>
  </modal>
</template>

<script>
import Modal from '../../layout/Modal/Modal';
import TimeUtils from '../../../utils/TimeUtils';
import ObjectUtil from '../../../utils/ObjectUtil';

export default {
  name: 'HistoryUpdateModal',
  components: { Modal },
  data() {
    return {
      show: false,
      historyList: [],
    };
  },
  methods: {
    formatMode(mode) {
      if (mode === 'UPDATE') {
        return 'Nouveau solde';
      } else if (mode === 'DEDUCTION') {
        return 'Deduction';
      } else if (mode === 'INCREMENT') {
        return 'Incrementation';
      }
    },
    formatDate(date) {
      return TimeUtils.formatDateTime(date);
    },
    closeModal() {
      this.show = false;
      this.historyList = [];
    },
    openModal(list) {
      this.historyList = ObjectUtil.sortArrayOfObject(list, 'date', 1);
      this.show = true;
    },
  },
};
</script>

<style scoped>
</style>
